// In-memory ring buffer för senaste 30 användar-events. Används enbart av
// bug-rapport-flödet — eleven kan skicka in vad de gjorde precis innan
// felet utan att vi behöver polla något i backend.
//
// 30 events ger gott om plats för meningsfull kontext kvar även efter
// att bug-rapport-flödets egna klick (öppna panel, fyll fält, klicka
// Skicka) lagt sig överst. Tidigare 10 visade sig vara för litet i
// praktiken — efter en typisk bug-rapport-interaktion fanns bara 2-3
// pre-bug-events kvar i bufferten.
//
// Inga API-anrop, ingen DB-skrivning. Bara minne tills användaren stänger
// fliken eller skickar bug-rapport. ~3 KB max per session.

export interface ActivityEvent {
  type: "klick" | "navigering" | "konsol";
  label: string;
  url?: string;
  timestamp: number;
}

const MAX_EVENTS = 30;
const buffer: ActivityEvent[] = [];

export function pushActivity(ev: Omit<ActivityEvent, "timestamp">): void {
  buffer.push({ ...ev, timestamp: Date.now() });
  if (buffer.length > MAX_EVENTS) buffer.shift();
}

export function getActivity(): ActivityEvent[] {
  return [...buffer];
}

export function clearActivity(): void {
  buffer.length = 0;
}
